import { Pm } from './Pm';

class Raffle extends Pm {
    constructor() {
        super();
        this.baseUrl += '/raffle';
    }

    data({ raffleName, raffleTime, raffleStatus, currentPage, pageSize } = {}) {
        let raffleBeginTime;
        let raffleEndTime;
        if (raffleTime && raffleTime.length === 2) {
            [raffleBeginTime, raffleEndTime] = raffleTime;
        }
        return super.get('/data', {
            raffleName,
            raffleBeginTime,
            raffleEndTime,
            raffleStatus,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id } = {}) {
        return super
            .get('/get', {
                id,
            })
            .then(json => {
                const { data } = json.data;
                const {
                    raffleCover,
                    raffleAdImage,
                    raffleTemplateImage,
                    raffleDesc,
                    raffleBeginTime,
                    raffleEndTime,
                    fileBasePath,
                    rafflePrizeList,
                } = data;

                if (raffleCover) {
                    data.raffleCover = raffleCover.split(',').reduce((prev, curr) => {
                        prev.push({
                            name: curr,
                            address: fileBasePath + curr,
                        });
                        return prev;
                    }, []);
                } else {
                    data.raffleCover = [];
                }

                if (raffleAdImage) {
                    data.raffleAdImage = raffleAdImage.split(',').reduce((prev, curr) => {
                        prev.push({
                            name: curr,
                            address: fileBasePath + curr,
                        });
                        return prev;
                    }, []);
                } else {
                    data.raffleAdImage = [];
                }
                if (raffleTemplateImage) {
                    data.raffleTemplateImage = raffleTemplateImage.split(',').reduce((prev, curr) => {
                        prev.push({
                            name: curr,
                            address: fileBasePath + curr,
                        });
                        return prev;
                    }, []);
                } else {
                    data.raffleTemplateImage = [];
                }
                if (raffleDesc) {
                    data.raffleDesc = raffleDesc.split(',').reduce((prev, curr) => {
                        prev.push({
                            name: curr,
                            address: fileBasePath + curr,
                        });
                        return prev;
                    }, []);
                } else {
                    data.raffleDesc = [];
                }

                if (raffleBeginTime && raffleEndTime) {
                    data.raffleTime = [raffleBeginTime, raffleEndTime];
                } else {
                    data.raffleTime = [];
                }

                if (rafflePrizeList && rafflePrizeList.length) {
                    rafflePrizeList.forEach(item => {
                        const { rafflePrizeImage } = item;
                        if (rafflePrizeImage) {
                            item.rafflePrizeImage = rafflePrizeImage.split(',').reduce((prev, curr) => {
                                prev.push({
                                    name: curr,
                                    address: fileBasePath + curr,
                                });
                                return prev;
                            }, []);
                        } else {
                            item.rafflePrizeImage = [];
                        }
                        const { raffleDrawImage } = item;
                        if (raffleDrawImage) {
                            item.raffleDrawImage = raffleDrawImage.split(',').reduce((prev, curr) => {
                                prev.push({
                                    name: curr,
                                    address: fileBasePath + curr,
                                });
                                return prev;
                            }, []);
                        } else {
                            item.raffleDrawImage = [];
                        }
                        const { raffleNoticeImage } = item;
                        if (raffleNoticeImage) {
                            item.raffleNoticeImage = raffleNoticeImage.split(',').reduce((prev, curr) => {
                                prev.push({
                                    name: curr,
                                    address: fileBasePath + curr,
                                });
                                return prev;
                            }, []);
                        } else {
                            item.raffleNoticeImage = [];
                        }

                        const { rafflePrizeConfig } = item;
                        if (rafflePrizeConfig) {
                            const prizeConfig = JSON.parse(rafflePrizeConfig);
                            if (+item.rafflePrizeType === 1) {
                                item.money = prizeConfig.money ? +prizeConfig.money : undefined;
                            } else if (+item.rafflePrizeType === 2) {
                                item.selectDataList = prizeConfig.selectDataList || [];
                            } else if (+item.rafflePrizeType === 3) {
                                item.isNeedIdCard = prizeConfig.isNeedIdCard || false;
                            }
                        }
                    });
                }

                return json;
            });
    }

    save({
        id,
        raffleName,
        raffleCover,
        raffleAdImage,
        raffleTemplateImage,
        raffleDesc,
        raffleCodeNum,
        raffleTime,
        remarks,
        rafflePrizeList,
        isSubmit,
    } = {}) {
        let raffleCoverUrl;
        let raffleAdImageUrl;
        let raffleTemplateImageUrl;
        let raffleDescUrl;
        let raffleBeginTime;
        let raffleEndTime;
        if (raffleCover && raffleCover.length) {
            raffleCoverUrl = raffleCover
                .reduce((prev, curr) => {
                    prev.push(curr.name);
                    return prev;
                }, [])
                .join(',');
        }
        if (raffleAdImage && raffleAdImage.length) {
            raffleAdImageUrl = raffleAdImage
                .reduce((prev, curr) => {
                    prev.push(curr.name);
                    return prev;
                }, [])
                .join(',');
        }
        if (raffleTemplateImage && raffleTemplateImage.length) {
            raffleTemplateImageUrl = raffleTemplateImage
                .reduce((prev, curr) => {
                    prev.push(curr.name);
                    return prev;
                }, [])
                .join(',');
        }
        if (raffleDesc && raffleDesc.length) {
            raffleDescUrl = raffleDesc
                .reduce((prev, curr) => {
                    prev.push(curr.name);
                    return prev;
                }, [])
                .join(',');
        }
        if (raffleTime && raffleTime.length === 2) {
            [raffleBeginTime, raffleEndTime] = raffleTime;
        }

        if (rafflePrizeList && rafflePrizeList.length) {
            rafflePrizeList = rafflePrizeList.map(item => {
                const res = { ...item };
                const { rafflePrizeImage } = res;
                if (rafflePrizeImage && rafflePrizeImage.length) {
                    res.rafflePrizeImage = rafflePrizeImage
                        .reduce((prev, curr) => {
                            prev.push(curr.name);
                            return prev;
                        }, [])
                        .join(',');
                } else {
                    res.rafflePrizeImage = '';
                }
                const { raffleDrawImage } = res;
                if (raffleDrawImage && raffleDrawImage.length) {
                    res.raffleDrawImage = raffleDrawImage
                        .reduce((prev, curr) => {
                            prev.push(curr.name);
                            return prev;
                        }, [])
                        .join(',');
                } else {
                    res.raffleDrawImage = '';
                }
                const { raffleNoticeImage } = res;
                if (raffleNoticeImage && raffleNoticeImage.length) {
                    res.raffleNoticeImage = raffleNoticeImage
                        .reduce((prev, curr) => {
                            prev.push(curr.name);
                            return prev;
                        }, [])
                        .join(',');
                } else {
                    res.raffleNoticeImage = '';
                }
                return res;
            });
        }

        return super.post('/save', {
            id,
            raffleName,
            raffleCover: raffleCoverUrl,
            raffleAdImage: raffleAdImageUrl,
            raffleTemplateImage: raffleTemplateImageUrl,
            raffleDesc: raffleDescUrl,
            raffleCodeNum,
            raffleBeginTime,
            raffleEndTime,
            remarks,
            rafflePrizeList: JSON.stringify(rafflePrizeList),
            isSubmit,
        });
    }

    delete({ id } = {}) {
        return super.post('/delete', {
            id,
        });
    }

    selectByPage({ raffleName, raffleTime, currentPage, pageSize } = {}) {
        let raffleBeginTime;
        let raffleEndTime;
        if (raffleTime && raffleTime.length === 2) {
            [raffleBeginTime, raffleEndTime] = raffleTime;
        }
        return super.get('/selectByPage', {
            raffleName,
            raffleBeginTime,
            raffleEndTime,
            currentPage,
            pageSize,
        });
    }

    finishRaffle({ id } = {}) {
        return super.post('/finishRaffle', {
            id,
        });
    }
}
export default new Raffle();
export { Raffle };
